module.exports = __webpack_public_path__ + "static/media/PHP.8ac2488a.svg";